import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';
import { localStoragevarNames } from '../../utilities/local-storage-utils';
import { Router } from '@angular/router';
import { pathNames } from '../../utilities/routing-path-utils';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppComponentEventsService } from '../../events/app-component-events.service';
import { resetUserInLocalStorage } from '../../utilities/user-utils';

@Component({
  selector: 'app-auth-success-page',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './auth-success-page.component.html',
  styleUrl: './auth-success-page.component.scss'
})
export class AuthSuccessPageComponent {
  constructor(
    private userService: UserService,
    private appEventService: AppComponentEventsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.fetchLoggedUserThenRedirect();
  }

  fetchLoggedUserThenRedirect(){
    this.userService.fetchLoggedUser().subscribe({
      next: (user) => {
        resetUserInLocalStorage(user);
        this.appEventService.onUserLogInEvent.emit();
        this.router.navigate([`/${pathNames.aiAgentConfigurationPath}`]);
      },
      error: () => {
        alert('Error from server contact support');
      }
    });
  }
}
